var runtime = require("../../../../../../../../wix-vod-widget/build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"icon":"_3_N-U"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._3_N-U{overflow:hidden}"+wrap+" ._3_N-U svg{height:100%;width:auto}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

